import { create } from 'zustand';
import { WorkContentMode } from '../enum/EnumRepository';

interface WorkContentModeState {
  workContentMode: WorkContentMode;
  setWorkContentMode: (mode: WorkContentMode) => void;
}

export const useWorkContentModeStore = create<WorkContentModeState>((set) => ({
  workContentMode: WorkContentMode.Orig,
  setWorkContentMode: (mode) => set({ workContentMode: mode }),
}));
